import { Box, TextField } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCGState } from "../customerGroupSetupSlice";

const w150 = 150;

export default function Comments() {
	const dispatch = useDispatch();
	const cgState = useSelector((store) => store.customerGroupSetup);
	const { editComments } = cgState;

	function setEditComments(event) {
		const text = event.target.value;
		dispatch(setCGState("editComments", text));
	}

	return (
		<Box sx={{ width: "100%", mt: 2 }}>
			<TextField
				className={"fullHeight fullWidth"}
				value={editComments}
				onChange={setEditComments}
				overflow="scroll"
				multiline
				id="outlined-basic"
				label=""
				rows={6}
				variant="outlined"
				size="large"
				InputProps={{ sx: { height: w150 }, autoComplete: "off" }}
			/>
		</Box>
	);
}
